import { ServiceProxy } from './ServiceProxy';
export class DataServiceProxy extends ServiceProxy {
  get(target, p) {
    if (p === 'dataType') {
      return target.dataType;
    }
    return super.get(target, p);
  }
}